import React, { useState } from "react";
import { Card, Dropdown, Button } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import AddLeaveModal from "../../modals/dashboard/employee-dashboard/AddLeaveModal";

/* Year based leave data */

const leaveData = {
  2026: {
    total: 16,
    taken: 10,
    absent: 2,
    request: 0,
    worked: 240,
    loss: 2
  },
  2025: {
    total: 20,
    taken: 12,
    absent: 3,
    request: 1,
    worked: 220,
    loss: 4
  },
  2024: {
    total: 18,
    taken: 8,
    absent: 5,
    request: 0,
    worked: 200,
    loss: 6
  }
};

export default function LeaveSummaryCard() {

const [show,setShow] = useState(false)
const [year,setYear] = useState("2026")

const data = leaveData[year]

return (

<Card className="leave-summary-card h-100">

<Card.Header className="d-flex justify-content-between align-items-center card-header-custom ">

<h5 className="card-title">Leave Details</h5>

<Dropdown>

<Dropdown.Toggle
variant="light"
className="year-btn"
>

<FiCalendar className="me-1"/> {year}

</Dropdown.Toggle>

<Dropdown.Menu>

{Object.keys(leaveData).map((y)=>(
<Dropdown.Item key={y} onClick={()=>setYear(y)}>
{y}
</Dropdown.Item>
))}

</Dropdown.Menu>

</Dropdown>

</Card.Header>


<Card.Body>

<div className="row">

<div className="col-6 stat-box">
<span>Total Leaves</span>
<h4>{data.total}</h4>
</div>

<div className="col-6 stat-box">
<span>Taken</span>
<h4>{data.taken}</h4>
</div>

<div className="col-6 stat-box">
<span>Absent</span>
<h4>{data.absent}</h4>
</div>

<div className="col-6 stat-box">
<span>Request</span>
<h4>{data.request}</h4>
</div>

<div className="col-6 stat-box">
<span>Worked Days</span>
<h4>{data.worked}</h4>
</div>

<div className="col-6 stat-box">
<span>Loss of Pay</span>
<h4>{data.loss}</h4>
</div>

<div className="col-12">

<Button
className="apply-btn w-100"
onClick={()=>setShow(true)}
>
Apply New Leave
</Button>

</div>

</div>

</Card.Body>

<AddLeaveModal show={show} setShow={setShow}/>


<style>{`

.leave-summary-card{
border-radius:5px;
border:2px solid #e5e7eb;

}

.dropdown-toggle::after {
  display: none !important; }
      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
.card-title{
font-weight:600;
}

.year-btn{
border:1px solid #e5e7eb;
background:#fff;
font-size:13px;
padding:6px 12px;
}

.stat-box{
margin-bottom:20px;
}

.stat-box span{
display:block;
font-size:13px;
color:#6b7280;
margin-bottom:4px;
}

.stat-box h4{
font-size:19px;
font-weight:700;
color:#0f172a;
}

.apply-btn{
background:#0f172a;
border:none;
border-radius:8px;
padding:9px;
font-weight:500;
margin-top:5px;
}

.apply-btn:hover{
background:#020617;
}

@media(max-width:1024px){

.leave-summary-card{
margin-top:20px;
}

}

`}</style>

</Card>

)

}